import Vue from 'vue'
import VueResource from 'vue-resource'
import { deleteCookie } from '@/common/js/cookies'
import { Toast } from 'mint-ui'
import { Indicator } from 'mint-ui'
Vue.use(VueResource)
import { loadFromLocal } from '@/common/js/store'

// 配置API接口地址
var root = '/_data';
// 将request body以application/x-www-form-urlencoded content type发送
// Vue.http.options.emulateJSON = true;
// 发送PUT, PATCH, DELETE请求时以HTTP POST的方式发送，并设置请求头的X-HTTP-Method-Override
Vue.http.options.emulateHTTP = true;
// Vue.http.options.headers = {
//   'Content-Type': 'application/json; charset=UTF-8',
//   'Accept': 'application/json, text/plain, */*'
// }
// 请求拦截器
Vue.http.interceptors.push((request, next) => {
  // ...
  // 请求发送前的处理逻辑
  // ...
  if (loadFromLocal('token')) {
    if (!request.params) {
      request.params = {}
    }
    request.params['access-token'] = loadFromLocal('token')
    // request.params['access-token'] = 'cXACbfqyizcbpcKF84DvOa5TTCIFkVJI'
  }
  if (request.method === 'POST') {
    if (request.url === '/_data/user/upload') {
      request.headers.set('content-type', 'multipart/form-data')
    }
  }
  var api_name = request.url.substring(request.url.lastIndexOf('/') + 1, request.url.length)
  switch(api_name)
  {
  case 'get-all-new':
    break;
  case 'get-new':
    break;
  case 'get-list':
    break;
  case 'get-balance':
    break;
  case 'send':
    break;
  default:
    Indicator.open()
  }
  request.credentials = true
  // console.log(request, window.location)
  // 请求超时10秒
  let timeout = setTimeout(() => {
    request.abort()
    Toast('请求超时，请刷新页面')
  }, 10000)
  next((response) => {
    // ...
    // 请求发送后的处理逻辑
    // ...
    clearTimeout(timeout)
    Indicator.close()
    // 根据请求的状态，response参数会返回给successCallback或errorCallback
    if (response.body.errcode) {
      if (response.body.errcode === 401) { // 登录超时，请重新登录
        deleteCookie('isLogined')
        // window.location.href = window.location.origin
        if(window.Router){
          window.Router.replace({
              path: '/login',
              // query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
          })
        }
      } else {
        // Toast({
        //   message: response.body.errmsg,
        //   duration: 10000
        // })
        Toast(response.body.errmsg)
      }
    }
  })
})

// 使用Vue.resource全局方式访问接口
export default {
  getApiUrl(url) {
    return root + '/' + url;
  },
  createResource(url, param_defaults, actions) {
    let inner_actions = {
      get: { method: 'GET', url: this.getApiUrl(url) },
      query: { method: 'GET', isArray: true },
      update: { method: 'PUT', url: this.getApiUrl(url) },
      remove: { method: 'DELETE', url: this.getApiUrl(url) },
      delete: { method: 'DELETE', url: this.getApiUrl(url) },
    };
    let inner_param_defaults = {};
    // if (getCookie('token')) {
    //   inner_param_defaults.PHPSESSID = getCookie('token');
    // }
    for(let x in actions){
      if (!actions[x].url.includes(root)) {
        actions[x].url = this.getApiUrl(actions[x].url)
      }
    }
    actions = Object.assign(inner_actions, actions);
    param_defaults = Object.assign(inner_param_defaults, param_defaults);
    return Vue.resource(this.getApiUrl(url), param_defaults, actions);
  }
}



// WEBPACK FOOTER //
// ./config/api.js